import React, { useState } from 'react'
import { Field } from 'formik';
import ResendPassword from './ResendPassword';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const OldUser = ({ values, touched, errors, loginType, timerForOtp, setTimerForOtp }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div>
            <div className="mb-4">
                <label htmlFor="userName" className="form-label">
                    Username *
                </label>
                <Field
                    type="text"
                    name="userName"
                    placeholder="Enter Username"
                    autoComplete="off"
                    disabled={loginType.step === 2}
                    className={`form-control ${touched.userName && errors.userName ? 'is-invalid' : ''}`}
                />
                {errors.userName && touched.userName ? (
                    <p className="errorMsg">{errors.userName}</p>) : null}
            </div>
            <div className="mb-4">
                <label htmlFor="password" className="form-label">
                    Password *
                </label>
                <div style={{ position: 'relative' }}>
                    <Field
                        // type={showPassword ? 'text' : 'password'}
                        type="text"
                        name='password'
                        placeholder="Enter Password"
                        autoComplete="off"
                        disabled={loginType.step === 2}
                        className={`form-control ${touched.password && errors.password ? 'is-invalid' : ''}`}
                        style={{ WebkitTextSecurity: showPassword ? "" : "disc" }}

                    />
                    <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        style={{
                            position: 'absolute',
                            right: '22px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        {showPassword ? <FaEye style={{ color: 'rgb(27, 35, 84)' }} /> : <FaEyeSlash style={{ color: 'rgb(27, 35, 84)' }} />}
                    </button>
                </div>
                {errors.password && touched.password ? (
                    <p className="errorMsg">{errors.password}</p>) : null}
            </div>

            {loginType?.step === 2 &&
                <ResendPassword
                    values={values}
                    errors={errors}
                    touched={touched}
                    timerForOtp={timerForOtp}
                    setTimerForOtp={setTimerForOtp}
                    loginType={loginType}

                />}
        </div>
    )
}

export default OldUser